import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  PassThroughAdapterdbgnfuhbpbsv as PassThroughAdapter,
  get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter,
  get_FloatAdapter8hkphxq3v57l as get_FloatAdapter,
  get_LongAdapter1acs38m0a7icu as get_LongAdapter,
  get_DoubleAdapter3vjvxl0ttbawu as get_DoubleAdapter,
  get_IntAdapter2kzerdn7hhunh as get_IntAdapter,
  get_BooleanAdapterefxw889yjdy4 as get_BooleanAdapter,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_UploadAdapter1jp2f4wtvjtde as get_UploadAdapter,
} from './Adapters.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from './ExecutionContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {
      constructor() {
        Key_instance = this;
        this.l46_1 = (new (Builder())()).c38();
        this.m46_1 = (new (Builder())()).s46(true).c38();
      }
    }
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  if (Key_instance === VOID)
    new (Key())();
  return Key_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.n46_1 = LinkedHashMap().bc();
        this.o46_1 = false;
        this.p46_1 = null;
        this.q46_1 = null;
        this.r46_1 = null;
      }
      t46(falseVariables) {
        // Inline function 'kotlin.apply' call
        this.p46_1 = falseVariables;
        return this;
      }
      u46(deferredFragmentIdentifiers) {
        // Inline function 'kotlin.apply' call
        this.q46_1 = deferredFragmentIdentifiers;
        return this;
      }
      v44(errors) {
        // Inline function 'kotlin.apply' call
        this.r46_1 = errors;
        return this;
      }
      v46(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.n46_1.z4(customScalarAdapters.a47_1);
        return this;
      }
      s46(unsafe) {
        // Inline function 'kotlin.apply' call
        this.o46_1 = unsafe;
        return this;
      }
      a5() {
        this.n46_1.a5();
      }
      c38() {
        return new (CustomScalarAdapters())(this.n46_1, this.p46_1, this.q46_1, this.r46_1, this.o46_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CustomScalarAdaptersClass;
function CustomScalarAdapters() {
  if (CustomScalarAdaptersClass === VOID) {
    class $ {
      constructor(customScalarAdapters, falseVariables, deferredFragmentIdentifiers, errors, unsafe) {
        Key_getInstance();
        this.w46_1 = falseVariables;
        this.x46_1 = deferredFragmentIdentifiers;
        this.y46_1 = errors;
        this.z46_1 = unsafe;
        this.a47_1 = customScalarAdapters;
      }
      b47(customScalar) {
        var tmp;
        if (!(this.a47_1.u4(customScalar.i46_1) == null)) {
          tmp = this.a47_1.u4(customScalar.i46_1);
        } else if (customScalar.h46_1 === 'com.apollographql.apollo.api.Upload') {
          tmp = get_UploadAdapter();
        } else if (listOf(['kotlin.String', 'java.lang.String']).t2(customScalar.h46_1)) {
          tmp = get_StringAdapter();
        } else if (listOf(['kotlin.Boolean', 'java.lang.Boolean']).t2(customScalar.h46_1)) {
          tmp = get_BooleanAdapter();
        } else if (listOf(['kotlin.Int', 'java.lang.Int']).t2(customScalar.h46_1)) {
          tmp = get_IntAdapter();
        } else if (listOf(['kotlin.Double', 'java.lang.Double']).t2(customScalar.h46_1)) {
          tmp = get_DoubleAdapter();
        } else if (listOf(['kotlin.Long', 'java.lang.Long']).t2(customScalar.h46_1)) {
          tmp = get_LongAdapter();
        } else if (listOf(['kotlin.Float', 'java.lang.Float']).t2(customScalar.h46_1)) {
          tmp = get_FloatAdapter();
        } else if (listOf(['kotlin.Any', 'java.lang.Object']).t2(customScalar.h46_1)) {
          tmp = get_AnyAdapter();
        } else if (this.z46_1) {
          tmp = new (PassThroughAdapter())();
        } else {
          // Inline function 'kotlin.error' call
          var message = "Can't map GraphQL type: `" + customScalar.i46_1 + '` to: `' + customScalar.h46_1 + '`. Did you forget to add a scalar Adapter?';
          throw IllegalStateException().o(toString(message));
        }
        var tmp_0 = tmp;
        return (!(tmp_0 == null) ? isInterface(tmp_0, Adapter()) : false) ? tmp_0 : THROW_CCE();
      }
      m3() {
        return Key_getInstance();
      }
      g44() {
        return (new (Builder())()).v46(this).t46(this.w46_1).u46(this.x46_1);
      }
    }
    protoOf($).c47 = get;
    protoOf($).d47 = fold;
    protoOf($).e47 = minusKey;
    protoOf($).t44 = plus;
    initMetadataForClass($, 'CustomScalarAdapters', VOID, VOID, [Element()]);
    CustomScalarAdaptersClass = $;
  }
  return CustomScalarAdaptersClass;
}
//region block: exports
export {
  Builder as Builder4ra56zvvku0a,
  Key_getInstance as Key_getInstance4887rkxhu93r,
};
//endregion

//# sourceMappingURL=CustomScalarAdapters.mjs.map
